import React from 'react';
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteIcon from '@mui/icons-material/Delete';
import SellIcon from '@mui/icons-material/Sell';
import { ConfirmActionDialog } from './ConfirmActionDialog';

interface VaultItemActionMenuProps {
  itemName: string;
  instanceId: string;
  salePrice: number;
  onDiscard: (instanceId: string) => void;
  onSell?: (instanceId: string) => void;
  buttonSx?: object;
}

export const VaultItemActionMenu: React.FC<VaultItemActionMenuProps> = React.memo(function VaultItemActionMenu({
  itemName,
  instanceId,
  salePrice,
  onDiscard,
  onSell,
  buttonSx,
}) {
  const [menuAnchor, setMenuAnchor] = React.useState<null | HTMLElement>(null);
  const [confirmSellOpen, setConfirmSellOpen] = React.useState(false);

  return (
    <>
      <IconButton
        size="small"
        onClick={(e) => setMenuAnchor(e.currentTarget)}
        sx={{ ml: 0.5, mt: -0.5, ...buttonSx }}
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu anchorEl={menuAnchor} open={Boolean(menuAnchor)} onClose={() => setMenuAnchor(null)}>
        <MenuItem onClick={() => { setMenuAnchor(null); onDiscard(instanceId); }}>
          <ListItemIcon><DeleteIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Discard</ListItemText>
        </MenuItem>
        {onSell && (
          <MenuItem onClick={() => { setMenuAnchor(null); setConfirmSellOpen(true); }}>
            <ListItemIcon><SellIcon fontSize="small" /></ListItemIcon>
            <ListItemText>Sell</ListItemText>
          </MenuItem>
        )}
      </Menu>
      {onSell && (
        <ConfirmActionDialog
          open={confirmSellOpen}
          title="Sell Item"
          message={`Sell ${itemName} for ${salePrice}gc?`}
          confirmLabel={`Sell for ${salePrice}gc`}
          onClose={() => setConfirmSellOpen(false)}
          onConfirm={() => { setConfirmSellOpen(false); onSell(instanceId); }}
        />
      )}
    </>
  );
});
